export default (localizedPageData, currentLocale) => {
  let localePrefix;
  if (localizedPageData.length > 1) {
    localePrefix = localizedPageData.find(
      (data) => data.locale === currentLocale
    ).language.short;
  }
  return localePrefix;
};
